// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Llnz","icon":"styles_icon__2wC0Q"};